import onHistoryRestored from './onHistoryRestored';

export default {
  onHistoryRestored,
};
